/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharechannelinstagramstory3Inputs */

const en_sharechannelinstagramstory3 = /** @type {(inputs: Sharechannelinstagramstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram story`)
};

const de_sharechannelinstagramstory3 = /** @type {(inputs: Sharechannelinstagramstory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram-Story`)
};

/**
* | output |
* | --- |
* | "Instagram story" |
*
* @param {Sharechannelinstagramstory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharechannelinstagramstory3 = /** @type {((inputs?: Sharechannelinstagramstory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharechannelinstagramstory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharechannelinstagramstory3(inputs)
	return de_sharechannelinstagramstory3(inputs)
});
export { sharechannelinstagramstory3 as "shareChannelInstagramStory" }